import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

export function initHomepageQuoteHeader() {
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=homepage-quote-header",
			homepageQuoteHeader
		);
	}
}

export function homepageQuoteHeader() {
	if (
		!document.querySelector(
			".homepage-quote-header .homepage-quote-header-swiper"
		)
	)
		return;

	var swiper = Swiper;
	var init = false;

	let wrapper = document.querySelector(
		".homepage-quote-header .homepage-quote-header-swiper > .swiper-wrapper-placeholder"
	);

	let slides = wrapper.querySelectorAll(".swiper-slide-placeholder");

	function swiperMode() {
		let mobile = window.matchMedia("(max-width: 1023px)");

		if (mobile.matches) {
			if (!init) {
				[...slides].forEach((v, i, a) => {
					v.classList.add("swiper-slide");
					v.classList.remove("px-4");
					v.removeAttribute("data-aos");
					//data-aos="fade-in"
				});
				wrapper.classList.add("swiper-wrapper");
				wrapper.classList.remove("flex-wrap", "-mx-4");
				init = true;
				swiper = new Swiper(
					".homepage-quote-header .homepage-quote-header-swiper",
					{
						modules: [Autoplay, EffectFade],
						effect: "fade",
                        speed: 1000,
						fadeEffect: {
							crossFade: true,
						},
						slidesPerView: 1,
						loop: true,
						centeredSlides: true,
						autoplay: {
							delay: 3000,
						},
					}
				);
			}
		} else {
			if (init) {
				swiper.destroy();
			}
			[...slides].forEach((v, i, a) => {
				v.classList.remove("swiper-slide");
				v.classList.add("px-4");
				v.setAttribute("data-aos", "fade-in");
				//data-aos="fade-in"
			});
			wrapper.classList.remove("swiper-wrapper");
			wrapper.classList.add("flex-wrap", "-mx-4");
			init = false;
		}
	}

	swiperMode();

	window.addEventListener("resize", function () {
		swiperMode();
	});
}
